import { useMemo } from "react";
import { useMunicipios, type Municipio } from "@/lib/municipios";
import type { CidadeMapa, Mapa } from "./api";

export type CidadeResolvida = CidadeMapa & Municipio;

export type Metrica = "dispensacoes" | "farmacias";

const numero = new Intl.NumberFormat("pt-BR");

export function formatNumero(valor: number): string {
  return numero.format(valor);
}

/**
 * Junta o que o backend manda (só código IBGE + contagens) com nome/UF/coordenadas
 * da tabela IBGE local. Código sem correspondência (tabela desatualizada) entra em
 * `naoEncontradas` em vez de sumir calado.
 */
export function useCidadesResolvidas(mapa: Mapa | undefined) {
  const municipios = useMunicipios();
  const resolvidas = useMemo(() => {
    const cidades: CidadeResolvida[] = [];
    let naoEncontradas = 0;
    if (mapa && municipios.data) {
      for (const cidade of mapa.cidades) {
        const municipio = municipios.data.porCodigo.get(cidade.codigoIbge);
        if (municipio) cidades.push({ ...municipio, ...cidade });
        else naoEncontradas++;
      }
    }
    return { cidades, naoEncontradas };
  }, [mapa, municipios.data]);

  return { ...resolvidas, isLoading: municipios.isLoading };
}

export function ordenarPor(cidades: CidadeResolvida[], metrica: Metrica): CidadeResolvida[] {
  const outra: Metrica = metrica === "dispensacoes" ? "farmacias" : "dispensacoes";
  return cidades
    .filter((c) => c[metrica] > 0)
    .sort((a, b) => b[metrica] - a[metrica] || b[outra] - a[outra] || a.nome.localeCompare(b.nome, "pt-BR"));
}
